// extracted by mini-css-extract-plugin
export default {"assets":"ExchangeConfiguration_assets__pGO-l","modal":"ExchangeConfiguration_modal__1PZKK","paper":"ExchangeConfiguration_paper__2f9Tm"};